export const onlineOrderData = [
    {
      id: "1",
      customer: "Carl Evans",
      image:"user-27.jpg",
      reference:"SL001",
      date:"24 Dec 2024",
      status:"Completed",
      total:"$1000",
      paid:"$1000",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "2",
      customer: "Minerva Rameriz",
      image:"user-02.jpg",
      reference:"SL002",
      date:"10 Dec 2024",
      status:"Pending",
      total:"$1500",
      paid:"$0.00",
      due:"$1500",
      paymentstatus:"Unpaid",
      biller:"Admin",
      action:"",
    },
    {
      id: "3",
      customer: "Robert Lamon",
      image:"user-05.jpg",
      reference:"SL003",
      date:"27 Nov 2024",
      status:"Completed",
      total:"$1500",
      paid:"$1800",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "4",
      customer: "Patricia Lewis",
      image:"user-22.jpg",
      reference:"SL004",
      date:"18 Nov 2024",
      status:"Completed",
      total:"$2000",
      paid:"$1000",
      due:"$1000",
      paymentstatus:"Overdue",
      biller:"Admin",
      action:"",
    },
    {
      id: "5",
      customer: "Mark Joslyn",
      image:"user-03.jpg",
      reference:"SL005",
      date:"06 Nov 2024",
      status:"Completed",
      total:"$800",
      paid:"$800",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "6",
      customer: "Marsha Betts",
      image:"user-12.jpg",
      reference:"SL006",
      date:"25 Oct 2024",
      status:"Pending",
      total:"$750",
      paid:"$0.00",
      due:"$750",
      paymentstatus:"Unpaid",
      biller:"Admin",
      action:"",
    },
    {
      id: "7",
      customer: "Daniel Jude",
      image:"user-06.jpg",
      reference:"SL007",
      date:"14 Oct 2024",
      status:"Completed",
      total:"$1300",
      paid:"$1300",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "8",
      customer: "Emma Bates",
      image:"user-21.jpg",
      reference:"SL008",
      date:"03 Oct 2024",
      status:"Completed",
      total:"$1100",
      paid:"$1100",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "9",
      customer: "Richard Fralick",
      image:"user-16.jpg",
      reference:"SL009",
      date:"20 Sep 2024",
      status:"Pending",
      total:"$2300",
      paid:"$2300",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
    {
      id: "10",
      customer: "Michelle Robison",
      image:"user-26.jpg",
      reference:"SL010",
      date:"10 Sep 2024",
      status:"Pending",
      total:"$1700",
      paid:"$1700",
      due:"$0.00",
      paymentstatus:"Paid",
      biller:"Admin",
      action:"",
    },
 
  ];